import { cn } from "@/lib/utils";

import { TEXT_DESCRIPTION } from "./typography";

export const SETTINGS_DIALOG_SHELL = "flex flex-col gap-6 overflow-hidden";

export const SETTINGS_DIALOG_HEADER = "space-y-2";

/** Reserve space for the absolute close button (`right-4 top-4`) on header titles. */
export const DIALOG_CLOSE_TEXT_CLEARANCE = "pr-8";

/** Offset trailing header actions (e.g. Create) left of the close button. */
export const DIALOG_CLOSE_ACTIONS_CLEARANCE = "mr-10";

export const SETTINGS_SCROLL_OUTER =
  "flex-1 min-h-0 overflow-y-auto -mx-6 px-6";

export const SETTINGS_SCROLL_INNER = "space-y-6 py-2 pb-4";

export const SETTINGS_FOOTER = "gap-3 border-t pt-5 sm:pt-5";

export const FORM_FIELD_STACK = "space-y-2";

export const READ_ONLY_BANNER_CLASSES = cn(
  "rounded-lg bg-foreground/[0.04] px-3 py-2.5",
  TEXT_DESCRIPTION,
);
